/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Status_Incidents_HintInputs */



/**
* | output |
* | --- |
* | "Live incidents from the status gateway. Read-only — created and resolved in oneDeploy." |
*
* @param {Partner_Status_Incidents_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_status_incidents_hint = /** @type {((inputs?: Partner_Status_Incidents_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Status_Incidents_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Aktuelle Störungen vom Status-Gateway. Schreibgeschützt – Erstellung und Behebung erfolgen in oneDeploy.")
	return /** @type {LocalizedString} */ ("Live incidents from the status gateway. Read-only — created and resolved in oneDeploy.")
});